import * as React from "react";
import * as Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import Select, { OptionTypeBase } from "react-select";
import * as Moment from "moment-timezone";
import uniqBy from "lodash-es/uniqBy";
import { Switch } from "../../forms/components/Switch";
import { useWebPortalApiClient } from "../api/WebPortalTokenClient";
import { TimeZone } from "webportalclient";

export type DateTimeOffsetPickerProps = {
    dateTime: string;
    onChange: (value: Moment.Moment) => void;
    className?: string;
};

export const DateTimeOffsetPicker = ({
    dateTime,
    onChange,
    className
}: DateTimeOffsetPickerProps) => {
    const [offsetOptions, setOffsetOptions] = React.useState([]);
    const [dateTimeValue, setDateTimeValue] = React.useState(Moment.parseZone(dateTime));
    const [offsetValue, setOffsetValue] = React.useState(Moment.parseZone(dateTime).utcOffset());
    const [isOffsetPickerVisible, setIsOffsetPickerVisible] = React.useState(false);
    const client = useWebPortalApiClient();

    React.useEffect(() => {
        const fetchTimeZoneOffsets = async () => {
            const timeZones = await client.client.getTimeZones();

            const offsetOptions: TimeZone[] = uniqBy(timeZones.value, tz => tz.OffsetInMinutes)
                .sort((a: TimeZone, b: TimeZone) => a.offsetInMinutes - b.offsetInMinutes)
                .map((tz: TimeZone) => ({
                    label: Moment()
                        .utcOffset(tz.offsetInMinutes)
                        .format("Z"),
                    value: tz.offsetInMinutes
                }));
            setOffsetOptions(offsetOptions);
        };

        fetchTimeZoneOffsets();
    }, []);

    const onChangeHandler = (time, offset) => {
        const removedOffset: Moment.Moment = Moment.utc(Moment(time).format("YYYY-MM-DD HH:mm:ss")); // Remove the offset as we are setting it ourselves from another control

        setDateTimeValue(time);
        setOffsetValue(offset);

        onChange(removedOffset.utcOffset(offset, true));
    };

    return (
        <div className="row">
            <div className="col-md-6">
            <Datetime
                className={className}
                defaultValue={dateTimeValue}
                onBlur={date => onChangeHandler(date, offsetValue)}
                dateFormat="DD-MMM-YYYY"
                timeFormat="HH:mm:ss"
                />
            </div>
            <div className="col-md-3">
                <Switch isToggledOn={isOffsetPickerVisible} label={isOffsetPickerVisible ? "Timezone Offset" : "Timezone"} onChange={() => setIsOffsetPickerVisible(!isOffsetPickerVisible)} />
            </div>
            <div className="col-md-3">
            {isOffsetPickerVisible ? (
                <Select
                    options={offsetOptions}
                    value={offsetOptions.filter(o => o.value === offsetValue)}
                    getOptionValue={o => o.value}
                    labelKey={o => o.label}
                    onChange={(option) =>
                        onChangeHandler(dateTimeValue, option ? option.value : null)
                    }
                />
                ) : null}
            </div>
        </div>
    );
};
